import React from 'react';
import { Tooltip } from '@mui/material';

/**
 * TooltipWrapper component that automatically handles MUI Tooltip warnings
 * by wrapping disabled child elements in a span when needed.
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child element(s)
 * @param {string} props.title - Tooltip title
 * @param {Object} props.tooltipProps - Additional props for Tooltip component
 */
const TooltipWrapper = ({ children, title, tooltipProps = {} }) => {
  // Check if the child is a disabled button/IconButton
  const isDisabledButton = React.Children.toArray(children).some(child => {
    if (React.isValidElement(child)) {
      return child.props.disabled === true;
    }
    return false;
  });

  // If it's a disabled button, wrap it in a span to prevent MUI warning
  if (isDisabledButton) {
    return (
      <Tooltip title={title} {...tooltipProps}>
        <span>
          {children}
        </span>
      </Tooltip>
    );
  }

  // Otherwise, render normally
  return (
    <Tooltip title={title} {...tooltipProps}>
      {children}
    </Tooltip>
  );
};

export default TooltipWrapper;
